module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/105.6b6e7407.png";